<template>
  <v-flex
    class="job"
    :class="{
      bgSingle: isSingleJob,
      preferred: jobDetails.JobInfo.Preferred,
      'job-submitted': jobAllreadyApplied,
    }"
  >
    <v-flex v-if="jobDetails.JobInfo.IsExpired">
      <p class="job-expired display-30 bold text-center red--text py-2">
        לצערנו המשרה כבר לא בתוקף
      </p>
    </v-flex>
    <JobHeader
      :jobDetails="jobDetails"
      :isFavorite="isFavorite"
      :isSingleJob="isSingleJob"
      :jobApplied="jobAllreadyApplied"
      :job-index="jobIndex"
      :recomended-job="recomendedJob"
      :listingid="`${jobDetails.JobInfo.STSJobCode}`"
      :isAA="isAA"
      :ssasource="ssasource"
      :showRank="showRank"
      class="job-hdr"
      :currentPage="currentPage"
      :WhatFieldText="WhatFieldText"
      :is-hitech="isHitech"
    />
  </v-flex>
</template>

<script>
import JobHeader from '@/components/Jobs_List/Job_Header/JobHeader.vue';
import gtm from '@/lib/gtm';
import { mapGetters } from 'vuex';

export default {
  components: {
    JobHeader,
  },

  data() {
    return {};
  },

  props: {
    isHitech: {
      type: Boolean,
      required: false,
      default: false,
    },
    //  recommender_CV Popup| recommender_HomePage| recommender_Single Job | recommender_Personal Area| recommender_Search Results
    currentPage: {
      type: String,
      required: false,
      default: '',
    },
    ssasource: {
      type: Number,
      required: false,
      default: 0,
    },
    isAA: {
      type: Boolean,
      required: false,
      default: false,
    },
    jobIndex: {
      type: Number,
      required: false,
      default: 0,
    },

    recomendedJob: {
      type: Boolean,
      required: false,
      default: false,
    },

    isSingleJob: Boolean,
    jobDetails: {
      type: Object,
      required: true,
      default: () => {},
    },
    showRank: {
      type: Boolean,
      required: false,
      default: false,
    },
    previewjob: {
      type: Boolean,
      required: false,
      default: false,
    },
    WhatFieldText: {
      type: String,
      required: false,
      default: '',
    },

  },
  mounted() {
    /** job impression event for each job  item*/
    if (this.jobDetails.JobInfo.IsRecommender) {
      const dataLayer = {
        category: 'recommender',
        action: 'job impression',
        label: this.jobDetails.JobAnalytics.name, //job_name
        cd68: this.jobDetails.JobAnalytics.cd68, //IDjob
        cd69: this.jobDetails.JobAnalytics.cd69, //position
        cd70: this.currentPage,
        event: 'drushim_recommender',
        search: this.WhatFieldText,
      };
      // gtm(_dataLayer);
      gtm(dataLayer);
    }
  },

  computed: {
    ...mapGetters(['checkIfJobIsLiked', 'checkIfAppliedForJob']),

    /**
     * isFavorite check if the jobe code exists in the store => sending the value as a prop to Footer , Header
     */
    isFavorite() {
      return this.checkIfJobIsLiked(this.jobDetails.Code);
    },

    jobAllreadyApplied() {
      return this.checkIfAppliedForJob(this.jobDetails.Code);
    },
  },
};
</script>

<style lang="scss" scoped>
.job {
  box-shadow: 0px 0px 5px 0 rgb(156 153 153 / 46%);
}
.job:hover {
  box-shadow: rgb(0 0 0 / 15%) 0px 0px 4px 2px;
}

.vacancyOpen .job {
  background-color: #f6f7f9;
}

.bgSingle {
  background-color: #f6f7f9;
}
</style>
